import type { NextRouter } from 'next/router';

export const checkWlPage = (query: NextRouter['query']) => query?.wl === 'true' || query?.pageType === 'mobile';
